// 3rd party imports
import * as React from 'react';
import { Route } from 'react-router-dom';
import { RouteComponentProps } from 'react-router';
import { inject, observer } from 'mobx-react';
import Reaptcha from 'reaptcha';

// bernie
import { ContextStore } from 'bernie-core';

// mobx
import { CaptchaStore, UserAuthStore } from 'stores';

// components
import { SecureRoute } from './secure-route';
import { modifyLocaleParam } from '../../util/LocaleParamTransformer';

interface WithSecurityProps extends RouteComponentProps {
  context?: ContextStore;
  userAuth?: UserAuthStore;
  captcha?: CaptchaStore;
}

export const withSecurity = (
  insideComponent,
  path,
  secure = true,
  withCaptcha = false,
  withAuthorization = false,
  unAuthorizedPath = '/signin',
) => {
  @inject('userAuth', 'captcha', 'context')
  @observer
  class ComponentWithSecurity extends React.Component<WithSecurityProps> {
    constructor(props) {
      super(props);
      this.props.userAuth.hydrateHistory(this.props.history);
    }

    public render() {
      const locale = modifyLocaleParam(this.props.context.locale);
      const componentPath = path.replace(':localeName', locale);
      const redirectPath = unAuthorizedPath.replace(':localeName', locale);

      let route;

      if (secure) {
        route = (
          <SecureRoute
            requireAuthorization={withAuthorization}
            path={componentPath}
            component={insideComponent}
            redirectPath={redirectPath}
          />
        );
      } else {
        route = <Route path={componentPath} component={insideComponent} />;
      }

      return (
        <>
          {withCaptcha && (
            <Reaptcha
              ref={(ref) => this.props.captcha.setCaptchaRef(ref)}
              sitekey={this.props.context.recaptchaSiteKey}
              onVerify={this.props.captcha.verifyCallback}
              onExpire={this.props.captcha.expireCallback}
              size={'invisible'}
            />
          )}
          {route}
        </>
      );
    }
  }

  return ComponentWithSecurity;
};
